import { createPermission } from '@backstage/plugin-permission-common';

export const CCOE_ADMIN_READ_PERMISSION = 'velux.dev.admin';

export const ccoeAdminReadPermission = createPermission({
  name: CCOE_ADMIN_READ_PERMISSION,
  attributes: { action: 'read' },
});
